import { Link } from "@tanstack/react-router";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import SectionReveal from "./SectionReveal";

interface CTAStripProps {
  headline?: string;
}

const CTAStrip = ({ headline = "Ready for new floors?" }: CTAStripProps) => {
  return (
    <section className="bg-secondary py-16 lg:py-20">
      <div className="container mx-auto px-4 text-center">
        <SectionReveal>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-secondary-foreground mb-8">
            {headline}
          </h2>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="btn-shine text-lg px-8 gap-2">
              <a href="tel:17739342004">
                <Phone className="w-5 h-5" />
                Call (773) 934-2004
              </a>
            </Button>
            <Button variant="outline" size="lg" asChild className="text-lg px-8 border-foreground/30 text-foreground bg-card hover:bg-muted">
              <Link to="/contact" hash="form">Request Estimate Online</Link>
            </Button>
          </div>
        </SectionReveal>
      </div>
    </section>
  );
};

export default CTAStrip;
